<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left">
				{{ $t('contract.new_contract') }}

			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<form>
			<b-container fluid>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="createContract.comment">{{ $t('contract.comment') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-input size="sm" id="comment"
										  v-model="createContract.comment"
										  name="comment"
										  autocomplete="off"
										  v-validate="validators.comment"
										  :state="checkField('comment')"
										  :placeholder="$t('contract.comment')"
							>
							</b-form-input>

						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="createContract.contractDate">{{ $t('contract.contractDate') }}</label>
						</b-col>
						<b-col sm="9">
							<masked-input v-model="createContract.contractDate"
										  mask="11-11-1111"
										  class="form-control form-control-sm"
							/>

						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="createContract.contractNumber">{{ $t('contract.contractNumber') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-input size="sm" id="contractNumber"
										  v-model="createContract.contractNumber"
										  name="contractNumber"
										  autocomplete="off"
										  v-validate="validators.contractNumber"
										  :state="checkField('contractNumber')"
										  :placeholder="$t('contract.contractNumber')"
							>
							</b-form-input>

						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="createContract.type">{{ $t('contract.type') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-select v-model="createContract.type"
										   v-validate="validators.type"
										   :plain="false"
										   size="sm"
										   :required="true"
										   :text-field="'name'"
										   :value-field="'id'"
										   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">

								<template>
									<option :value="null" disabled>
										--{{ $t('contract.type') }}--
									</option>
									<option value="PUL_BERILADI">Денгьи будут отданы</option>
									<option value="PUL_OLINADI">Деньги будут взяты</option>

								</template>
							</b-form-select>

						</b-col>
					</b-row>
				</b-form-group>

				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="createContract.contragentName">{{ $t('contract.contragentName') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-select
								v-model="createContract.contragentName"
								size="sm"
								@change="detectOption"

							>
								<option v-for="(selectOption, indexOpt) in dropdowns.counterparties"
										:key="indexOpt"
										:value="selectOption"
								>
									{{ selectOption.fullName }}
								</option>
								<template slot="first">
									<option :value="null" disabled>-- {{ $t('contract.contragentName') }} --</option>
								</template>
							</b-form-select>

						</b-col>
					</b-row>
				</b-form-group>



				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="createContract.responsibleName">{{ $t('contract.responsibleName') }}</label>
						</b-col>
						<b-col sm="9">

							<multiselect class="pull-left with-clear" v-model="createContract.responsibleName"
										 :options="employees"
										 :searchable="true"
										 :loading="dropdowns.loading"
										 :close-on-select="true"
										 label="name"
										 :selectLabel="''"
										 :deselectLabel="''"
										 track-by="id"
										 :custom-label="fullName"
										 @search-change="fetchEmployees($event)"
										 :placeholder="$t('incomes.create.select-employee')">

							</multiselect>

						</b-col>
					</b-row>
				</b-form-group>

				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="createContract.stageName">{{ $t('contract.stageName') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-select
								v-model="createContract.stageName"
								size="sm"

							>
								<option v-for="(selectOption, indexOpt) in dropdowns.contract_stage"
										:key="indexOpt"
										:value="selectOption"
								>
									{{ selectOption.name }}
								</option>
								<template slot="first">
									<option :value="null" disabled>-- {{ $t('contract.stageName') }} --</option>
								</template>
							</b-form-select>

						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="createContract.priceUsd">{{ $t('contract.priceUsd') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-input size="sm" id="priceUsd"
										  v-model="createContract.priceUsd"
										  name="priceUsd"
										  autocomplete="off"
										  v-validate="validators.priceUsd"
										  :state="checkField('priceUsd')"
										  :placeholder="$t('contract.priceUsd')"
							>
							</b-form-input>

						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="createContract.priceUzs">{{ $t('contract.priceUzs') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-input size="sm" id="priceUzs"
										  v-model="createContract.priceUzs"
										  name="priceUzs"
										  autocomplete="off"
										  v-validate="validators.priceUzs"
										  :state="checkField('priceUzs')"
										  :placeholder="$t('contract.priceUzs')"
							>
							</b-form-input>

						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="createContract.completed">{{ $t('contract.completed') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-select v-model="createContract.completed"
										   v-validate="validators.completed"
										   :plain="false"
										   size="sm"
										   :required="true"
										   :text-field="'name'"
										   :value-field="'id'"
										   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">

								<template>
									<option :value="null" disabled>
										--{{ $t('contract.completed') }}--
									</option>
									<option value="true">{{$t('contract.completed_yes')}}</option>
									<option value="false">{{$t('contract.completed_not')}}</option>

								</template>
							</b-form-select>

						</b-col>
					</b-row>
				</b-form-group>







			</b-container>

			<div class="modal-actions">
				<b-row class="align-items-center">
					<b-col cols="6" class="mb-3 mb-xl-0">
						<b-row>
							<b-col cols="6">
								<b-button block size="sm" type="button" @click="cancel" variant="outline-danger">{{
									$t('cancel') }}
								</b-button>
							</b-col>
							<b-col cols="6">
								<b-button block type="button" size="sm" @click="create" variant="primary">{{ $t('save')
									}}
								</b-button>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>

		</form>
	</div>
</template>

<script>

	import {validators} from "../mixins/validators";
	import Employees from "../mixins/Employee";
	import {mapActions, mapGetters} from "vuex";
	import MaskedInput from 'vue-masked-input'
	import ContrAgentService from '../../../../services/contragent.service'
	import ReferenceService from '../../../../services/references.sevice'
	import EmployeeService from '../../../../services/employees.service'
	import Multiselect from 'vue-multiselect'

	export default {
		name: 'AddContract',
		props: {
			mode: {
				type: String,
				default: 'create'
			},
			edit: {
				type: Object,
				default: null
			}

		},
		mixins: [Employees,validators],
		data(){
			return {
				newContract: {
					comment: '',
					contractDate: '',
					contractNumber: '',
					type:null,
					contragentId: '',
					contragentName:null,
					responsibleId: '',
					responsibleName: '',
					stageId: '',
					stageName: null,
					priceUsd: '',
					priceUzs: '',
					completed: null,
				},
				dropdowns: {
					counterparties:[],
					contract_stage:[],
					responsiblelIds: [],
					responsiblelNames: [],
					contractIds: [],
					contragentNames:[],
					loading: false

				},

				childModal: false
			}
		},
		methods: {
			...mapActions('contract',['createOrUpdateContract']),
			cancel() {
				this.$emit('close', true);
			},
			loadContragents() {
				ContrAgentService.search({
					page: 1, limit: 700
				}).then(response => {
					this.dropdowns.counterparties = response.data.items;

				})
			},
			loadContractStages(){
				ReferenceService.getReferenceChildren("CONTRACT_STAGE").then(response => {
					this.dropdowns.contract_stage = response.data;
				})
			},
			loadResponsibles(){
				EmployeeService.search({
					page: 1, limit: 10
				}).then(response => {
					this.dropdowns.transferPermittedDepartments = response.data.items;
				})
			},
			fullName({ firstName, lastName, middleName }) {
				return `${firstName} ${lastName} ${middleName}`;
			},
			detectOption($event){
			},

			async create() {

				this.$validator.validate().then(valid => {
					if (valid) {
						let contarct = {

								comment: this.createContract.comment,
								contractDate: this.createContract.contractDate,
								contractNumber: this.createContract.contractNumber,
								type: this.createContract.type,
								contragentId: this.createContract.contragentName.id,
								contragentName:this.createContract.contragentName.fullName,
								responsibleId: this.createContract.responsibleName.id,
								responsibleName: this.createContract.responsibleName.firstName + ' ' + this.createContract.responsibleName.lastName + ' ' + this.createContract.responsibleName.middleName ,
								stageId: this.createContract.stageName.id,
								stageName: this.createContract.stageName.name,
								priceUsd: this.createContract.priceUsd,
								priceUzs: this.createContract.priceUzs,
								completed: this.createContract.completed,
						}

						if(this.mode === 'edit')
							contarct.id = this.edit.id
						try {
							this.createOrUpdateContract(contarct)
								.then(response => {
									this.$emit('success', true);
								})
						}catch(error){
							throw error
						}


					} else {

						Object.keys(this.validationFields).some(key => {
							this.validationFields[key].touched = true;
							this.validationFields[key].dirty = true;
							this.validationFields[key].changed = true;
						});

						this.$vs.notify({
							title: this.$t('words.error'),
							text: this.$t('words.validation-error'),
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					}
				});
				return false;
			},



		},
		created(){
			this.loadContragents()
			this.loadContractStages()
			this.loadResponsibles()
		},
		computed: {
			createContract() {
				if (this.mode === 'create') {

					return this.newContract
				} else {
					let obj = Object.assign({}, this.edit);
					let contragentName = this.dropdowns.counterparties.find(contragent =>
						contragent.id === this.edit.contragentId
					)


					let stageName = this.dropdowns.contract_stage.find( stage =>
						stage.id === this.edit.stageId
					)


					let responsibleName = this.employees.find( responsible =>
						responsible.id === this.edit.responsibleId
					)



					obj.contragentName = contragentName
					obj.stageName = stageName
					obj.responsibleName = responsibleName
					return obj;
				}
			}
		},
		beforeMount() {

		},
		components: {
			MaskedInput,
			Multiselect
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped></style>
